import { useIntl } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { ListingData } from "~/context/ListingPageDataContext";
import { BookListingQuote, IBooking } from "~/types/api-types";

import { getBookListingButtonText } from "../book-listing-utils";

type BookListingSubmitButtonProps = {
  quote: BookListingQuote | undefined;
  booking: IBooking | undefined;
  listingData: ListingData;
  onClick: () => void;
};

export const BookListingSubmitButton = ({
  quote,
  booking,
  listingData,
  onClick,
}: BookListingSubmitButtonProps) => {
  const intl = useIntl();

  const buttonText = getBookListingButtonText({
    quote,
    booking,
    listingData,
    intl,
  });

  return (
    <Button
      size="large"
      appearance="purple"
      fullWidth
      data-testing-id="requestToBookButton"
      onClick={onClick}
    >
      {buttonText}
    </Button>
  );
};
